<template>
  <div
    class="bg-slate-100 h-screen px-2 lg:px-24 py-5 pb-2 hidden lg:block md:hidden"
  >
    <div>
      <h4 class="font-zilla text-2xl lg:text-5xl font-extrabold">Gitly</h4>
    </div>
    <div class="flex justify-between">
      <div class="mt-56">
        <h4 class="font-zilla font-extrabold text-5xl">
          Access all your Github Repositories
        </h4>
        <h4 class="font-zilla font-extrabold text-4xl">
          Including Collaborations all in one place.
        </h4>
        <div class="flex justify-center">
          <button
            @click="redirectToGitHub()"
            class="py-3 px-6 bg-slate-900 text-white hover:bg-slate-400 hover:text-black hover:shadow-lg font-extrabold font-zilla mt-6 rounded-md"
          >
            Authorize github
          </button>
        </div>
      </div>

      <img class="w-[50vh]" v-lazy="require('../assets/mockup3.png')" />
    </div>

    <div class="fixed bottom-2 flex justify-center items-center">
      <h4 class="font-zilla text-xl font-extrabold mb-3">
        Collins &copy; 2024
      </h4>
    </div>
  </div>

  <div class="bg-slate-100 h-auto px-2 lg:hidden flex-row justify-center">
    <div class="flex justify-center">
      <h4 class="font-zilla text-2xl mt-10 font-extrabold">Gitly</h4>
    </div>

    <div class="flex justify-center mt-6">
      <h4 class="font-zilla font-extrabold text-xl">
        Access all your Github Repositories
      </h4>
    </div>

    <div class="flex justify-center">
      <h4 class="font-zilla font-extrabold text-md">
        Including Collaborations in one place
      </h4>
    </div>

    <div class="mt-18">
      <div class="flex justify-center">
        <button
          @click="redirectToGitHub()"
          class="py-3 px-6 bg-slate-900 text-white hover:bg-slate-400 hover:text-black hover:shadow-lg font-extrabold font-zilla mt-6 rounded-md"
        >
          Authorize github
        </button>
      </div>
    </div>
    <div class="flex justify-center">
      <img class="w-[50vh]" v-lazy="require('../assets/mockup3.png')" />
    </div>

    <a
      class="flex justify-center items-center"
      href="https://github.com/ikotun-dev"
    >
      <h4 class="underline font-zilla text-md font-extrabold mb-3">
        Collins &copy; 2024
      </h4>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      redirectedUrl: null,
    };
  },
  methods: {
    redirectToGitHub() {
      const authUrl = "https://quasar1.up.railway.app/login";

      // Open a new window or redirect the entire page to the authorization URL
      window.location.href = authUrl;
    },
  },
};
</script>
